import { FormEvent, useState } from 'react';

interface SeedFormProps {
  loading: boolean;
  onCreate: (seed: string, groupALabel: string, groupBLabel: string) => Promise<void>;
}

export function SeedForm({ loading, onCreate }: SeedFormProps) {
  const [seed, setSeed] = useState('AI in schools');
  const [groupA, setGroupA] = useState('Move faster');
  const [groupB, setGroupB] = useState('Go carefully');

  async function submit(event: FormEvent) {
    event.preventDefault();
    await onCreate(seed, groupA, groupB);
  }

  return (
    <form className="seedForm card" onSubmit={submit}>
      <div>
        <span className="eyebrow">Seed</span>
        <h2>Make a divide playable.</h2>
        <p>
          Hidden Commons turns a tense topic into a live search for bridge statements: claims both sides endorse more than they expect.
        </p>
      </div>
      <label>
        Topic seed
        <input value={seed} onChange={(event) => setSeed(event.target.value)} maxLength={160} placeholder="e.g. AI in schools" />
      </label>
      <div className="twoCols">
        <label>
          Pull A
          <input value={groupA} onChange={(event) => setGroupA(event.target.value)} maxLength={42} />
        </label>
        <label>
          Pull B
          <input value={groupB} onChange={(event) => setGroupB(event.target.value)} maxLength={42} />
        </label>
      </div>
      <button className="primary" disabled={loading}>{loading ? 'Opening space…' : 'Open opinion space'}</button>
    </form>
  );
}
